module.exports = __webpack_public_path__ + "resources/img/img_csap_saas_guide_m.8b6f4d5c4dcd9e9f6db360b553f09052.png";